import { MakeLogicType, actions, kea, key, path, props, reducers, selectors } from 'kea'

export interface VirtualizedLogsListLogicProps {
    id: string
    scrollThreshold?: number
}

const DEFAULT_SCROLL_THRESHOLD = 100

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface virtualizedLogsListLogicValues {
    cellScrollLefts: Record<string, number>
    containerWidth: number
    shouldLoadMore: (stopIndex: number, dataSourceLength: number, hasMore: boolean, isLoading: boolean) => boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface virtualizedLogsListLogicActions {
    setCellScrollLeft: (
        cellKey: string,
        scrollLeft: number
    ) => {
        cellKey: string
        scrollLeft: number
    }
    setContainerWidth: (width: number) => {
        width: number
    }
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface virtualizedLogsListLogicMeta {
    key: string
    __keaTypeGenInternalSelectorTypes: {
        shouldLoadMore: (
            arg: any
        ) => (stopIndex: number, dataSourceLength: number, hasMore: boolean, isLoading: boolean) => boolean
    }
}

export type virtualizedLogsListLogicType = MakeLogicType<
    virtualizedLogsListLogicValues,
    virtualizedLogsListLogicActions,
    VirtualizedLogsListLogicProps,
    virtualizedLogsListLogicMeta
>

export const virtualizedLogsListLogic = kea<virtualizedLogsListLogicType>([
    props({ scrollThreshold: DEFAULT_SCROLL_THRESHOLD } as VirtualizedLogsListLogicProps),
    key((props) => props.id),
    path((id) => ['products', 'logs', 'frontend', 'components', 'VirtualizedLogsList', 'virtualizedLogsListLogic', id]),

    actions({
        setContainerWidth: (width: number) => ({ width }),
        setCellScrollLeft: (cellKey: string, scrollLeft: number) => ({ cellKey, scrollLeft }),
    }),

    reducers({
        containerWidth: [
            0,
            {
                setContainerWidth: (_, { width }) => width,
            },
        ],
        cellScrollLefts: [
            {} as Record<string, number>,
            { persist: true },
            {
                setCellScrollLeft: (state, { cellKey, scrollLeft }) => ({
                    ...state,
                    [cellKey]: scrollLeft,
                }),
            },
        ],
    }),

    selectors({
        shouldLoadMore: [
            () => [(_, props) => props.scrollThreshold ?? DEFAULT_SCROLL_THRESHOLD],
            (scrollThreshold) =>
                (stopIndex: number, dataSourceLength: number, hasMore: boolean, isLoading: boolean): boolean => {
                    if (!hasMore || isLoading) {
                        return false
                    }
                    return stopIndex >= dataSourceLength - scrollThreshold
                },
        ],
    }),
])
